'use client';

import {useTranslations} from 'next-intl';
import SliderBase from './SliderBase';

export default function StaffStorySlider(Prop: {
  moduleData: any;
  moduleOption?: any;
}) {
  const sliderSetting = Prop.moduleOption || {};
  const sliderItems = Prop.moduleData || [];
  const t = useTranslations('StaffStory');

  return (
    <SliderBase
      items={sliderItems}
      options={{withDots: true, basis: 'none', ...sliderSetting}}
      template={(sliderItem) => (
        <div className="flex flex-col items-start justify-center bg-[#fafafa] rounded-b-sm">
          {sliderItem.image && (
            <div className="w-full flex flex-col md:flex-row justify-center items-start p-4">
              <div className="w-[100%] md:w-[40%] mb-4">
                <img
                  className="w-full object-cover object-center h-[310px] md:h-[210px]"
                  src={sliderItem.image.url}
                  alt={sliderItem.name || ''}
                />
              </div>
              <div className="w-[100%] md:w-[60%] pl-8">
                <div className="flex flex-col  ">
                  <div>
                    <div className="text-[#e31837] text-[22px] font-[400]">
                      {sliderItem.name}
                    </div>
                    <div className=" text-sm">{sliderItem.brand}</div>
                    <div className=" text-sm">{sliderItem.job_title}</div>
                  </div>
                  <hr className="my-4" />
                  <div className="">
                    <div className="overflow-hidden text-md leading-[1.2] h-[65px]">
                      <div className="line-clamp-3 italic ">
                        {sliderItem.quote}
                      </div>
                    </div>
                  </div>
                </div>

                <a
                  href={'/our-people-story/' + sliderItem.slug}
                  className="flex justify-center items-center w-full mt-4 hover:text-[#e31837] hover:bg-transparent text-sm rounded-md border hover:border-[#e31837] py-2 px-4 bg-[#e31837] text-white"
                >
                  <div className="">{t('discoverOurStories')}</div>
                </a>
              </div>
            </div>
          )}
        </div>
      )}
    ></SliderBase>
  );
}
